import React from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import VerifiedIcon from '../Icons/VerifiedIcon';

const UserAvatar = ({ verified, classes, children, ...rest }) => (
  <div className={`user-avatar avatar-wrapper ${classes}`}>
    <Avatar {...rest} />
    {verified && <VerifiedIcon />}
    {children}
  </div>
);

UserAvatar.propTypes = {
  verified: PropTypes.bool,
  classes: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default UserAvatar;



// WEBPACK FOOTER //
// ./library/app/components/Global/Avatars/UserAvatar.js